import { useEerieBackdrop } from "@/lib/eerie";
import { MatchKeyJoin } from "@/components/MatchKey/MatchKeyShell";
import { PENTE_CFG } from "@/components/MatchKey/cfgs";

export default function PenteJoinPage() {
  useEerieBackdrop("pente");
  return <MatchKeyJoin cfg={PENTE_CFG} />;
}
